var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operator-container"},[_vm._m(0),_c('div',{staticClass:"speechBubble"},[_c('p',{staticClass:"speechText"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":require("@/assets/img/operator.png"),"alt":"operator"}})])
}]

export { render, staticRenderFns }